import styled from 'styled-components';

import { Link, media } from '@minerva-analytics/pantheon';
import { H3, LIGHT_GRAY } from 'root/theme';

const SubCategoryDisplayContainer = styled.div`
  width: 100%;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
`;

const CategoryHeadline = styled.h3`
  ${H3};
`;

const SpecialSubcategoryContainer = styled.div`
  display: flex;
  max-width: 900px;
  flex-direction: row;
  border-bottom: 1.5px solid ${LIGHT_GRAY};
  padding-bottom: 20px;
  margin-top: 1rem;
  ${media.medium`
    justify-content: center;
  `}
`;

const SubcategoryDifficultyContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 30px;
  ${media.medium`
    justify-content: center;
  `}
`;

const Paginator = styled.div`
`;

const NextLink = styled(Link)`
`;

export {
  SubCategoryDisplayContainer,
  CategoryHeadline,
  SpecialSubcategoryContainer,
  SubcategoryDifficultyContainer,
  Paginator,
  NextLink,
};
